// src/App.js
import React from "react";
import Footer from "./components/Footer";
import { ChakraProvider, Container, Box } from "@chakra-ui/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import theme from "./theme";

import Header from "./components/Header";
import PhotoCarousel from "./components/PhotoCarousel";
import Donations from "./components/Donations";
import AdminLogin from "./pages/AdminLogin";
import AdminUpload from "./pages/AdminUpload";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Deeds from "./pages/Deeds";
import Donate from "./pages/Donate";
import WhatsAppFloating from "./components/WhatsAppFloating";
import Expenditures from "./pages/Expenditures";
import Banner from "./components/Banner";
import TopDonorsAdvanced from "./components/TopDonorsAdvanced";
import InstallApp from "./components/InstallApp";

// Note: AskVillage (GramadevaAI) is intentionally NOT rendered here.
// It now lives only on the About page (src/pages/About.js), which
// manages its own local isOpen state — this keeps the assistant
// scoped to About instead of following the user across every page.

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Box
        minH="100vh"
        bgGradient="linear(to-br, #fffaf0, #fef9e7)"
        backgroundAttachment="fixed"
      >
        <BrowserRouter>
          <Header />

          <InstallApp />

          {/* Wider container to give two-column layout room to breathe,
              and an inner centered wrapper with explicit maxWidth for predictable centering. */}
          <Container maxW="container.lg" py={8} px={{ base: 3, md: 6 }}>
            <Box
              mx="auto"
              width="100%"
              maxW={{ base: "100%", md: "1100px" }} // explicit inner width for stable centering
            >
              <Routes>
                <Route
                  path="/"
                  element={
                    <>
                      <Banner />

                      <Box mb={8}>
                        <PhotoCarousel />
                      </Box>

                      {/* Golden Plate donor display */}
                      <TopDonorsAdvanced />

                      <Donations />
                    </>
                  }
                />

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/upload" element={<AdminUpload />} />
                <Route path="/about" element={<About />} />
                <Route path="/deeds" element={<Deeds />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/donate" element={<Donate />} />
                <Route path="/expenditures" element={<Expenditures />} />
              </Routes>
            </Box>
          </Container>

          <Footer />

          <WhatsAppFloating />
        </BrowserRouter>
      </Box>
    </ChakraProvider>
  );
}

export default App;
